const EMAIL_ADDRESS_TEXT_FORM_DATA = 'email-addresses';
const EMAIL_ADDRESS_CSV_FORM_DATA = 'csv-email-addresses';
const NOTIFY_LEARNERS_FORM_DATA = 'notify';
const NOTIFY_LEARNERS_LABEL = 'Notify learners';
const EMAIL_ADDRESS_CSV_LABEL = 'Upload email addresses';
const EMAIL_ADDRESS_TEXT_LABEL = 'Email addresses';
const MAX_EMAIL_ADDRESS_ALLOWED = 500;

export {
  MAX_EMAIL_ADDRESS_ALLOWED,
  EMAIL_ADDRESS_TEXT_FORM_DATA,
  EMAIL_ADDRESS_CSV_FORM_DATA,
  NOTIFY_LEARNERS_FORM_DATA,
  NOTIFY_LEARNERS_LABEL,
  EMAIL_ADDRESS_CSV_LABEL,
  EMAIL_ADDRESS_TEXT_LABEL,
};
